import React, { useContext, useState } from "react";
import Vehicle from "../components/Vehicle";
import AppContext from "../context";
import swal from "sweetalert2";
import axios from "axios";
import ContactInformationCheck from "../components/ContactInformationCheck";
import { useTranslation } from "react-i18next";

export default function CarLeadModal({ a, k }) {
	const { setModal } = useContext(AppContext);
	const [ajax, setAjax] = useState(false);
	const v = a.vehicles[k];
	const { t, i18n } = useTranslation();

	const getVehicleName = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return (
				(a.vehicles[k].vehicle_maker ? a.vehicles[k].vehicle_maker : "") +
				(a.vehicles[k].vehicle_model_year
					? " " + a.vehicles[k].vehicle_model_year
					: "")
			);
		}
		// return "Unknown vehicle";
	};

	const getVin = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return a.vehicles[k].vin_code;
		}
		// return "";
	};

	const getZip = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return a.vehicles[k].owner_zip;
		}
		// return "";
	};

	const submit = (data) => {
		setAjax(true);

		gtag("event", "page_view", {
			page_title: "Success",
			page_location: window.location.href,
			page_path: "/vehicle/success"
		});

		const headers = {
			'page-referrers': window.location.href
		}

		axios
			.post("/leads/create", {
				firstName: data.name.split(" ")[0],
				lastName: data.name.split(" ")[1],
				phone: data.phone,
				email: data.email,
				accidentId: a.custom_id,
				legal_consult: true,
				fault: false,
				injured:
					a.vehicles[k].participants[0] &&
					a.vehicles[k].participants[0].injury !== "NOT INJURED"
						? true
						: false,
				source: "car",
				occupant: getVehicleName(),
				vin: getVin(),
				zip: getZip(),
				state: a.state,
				language: i18n.language,
				trusted_form_cert: window.cert?.xxTrustedFormCertUrl || "",
				gclidcrm: window.gclidcrm || "",
			}, { headers })
			.then((d) => {
				if (d.data.success) {
					gtag("event", "car-success", {
						event_category: "car",
						event_label: "car-success-hot"
					});

					swal.fire(
						t("THANK_YOU"),
						t("THANK_YOU_FOR_REQUESTING_A_FREE_LEGAL_CONSULTATION"),
						"success"
					);
					setModal("");
				} else {
					swal.fire(
						"Error",
						"Some error ocurred while creating your request.",
						"error"
					);
				}
			})
			.catch((e) => {
				if (e.response.data.error === "blacklisted") {
					swal
						.fire(
							"Error",
							t("YOU_ARE_COMMERCIAL_USER__PLEASE_SIGN_UP_FOR_BUSINESS_SERVICE"),
							"warning"
						)
						.then(() => {
							window.location.href = "https://business.myaccident.org";
						});
				} else {
					swal.fire(
						"Error",
						"Some error ocurred while creating your request.",
						"error"
					);
				}
			});
	};
	return (
		<div id="car-lead" className={ajax ? "ajax" : ""}>
			<a className="close" onClick={() => setModal("")}>
				<img src="/assets/icon-close.png" alt="close" />
			</a>
			<div className="content">
				<h1>{t("WERE_YOU_AN_OCCUPANT_OF_THIS_VEHICLE_")}</h1>
				<div
					className="row"
					style={{
						maxWidth: 800,
						margin: "40px auto",
						alignItems: "flex-start"
					}}
				>
					<div>
						<h3>
							{v.vehicle_maker} {v.vehicle_model_year}
						</h3>
						<Vehicle v={v} alt />
					</div>
					<div>
						{t("BASED_ON_THE_FOLLOWING")}:
						<ul>
							<li>
								<img src="/assets/checked.png" alt="checked" />
								{t("ACCIDENT_SEVERITY")}
							</li>
							<li>
								<img src="/assets/checked.png" alt="checked" />
								{t("DATE_OF_ACCIDENT_WITHIN_STATUTE_OF_LIMITATION")}
							</li>
							<li>
								<img src="/assets/checked.png" alt="checked" />
								{t("THE_OTHER_DRIVER_WAS_AT_FAULT")}
							</li>
						</ul>
						<br />
						<br />
						<h2>{t("REQUEST_A_FREE_CASE_EVALUATION")}</h2>
						<br />
						<ContactInformationCheck
							next={(data) => {
								submit(data);
							}}
							back={() => setModal("")}
							hideTitle={true}
							smsSent={() => {}}
						/>
					</div>
				</div>
				<div
					style={{
						maxWidth: 800,
						margin: "40px auto"
					}}
				>
					{t("BY_SUBMITTING_THIS_REQUEST")}{" "}
					<a href="https://myaccident.org/terms-of-use" target="_blank">
						{t("TERMS_OF_USE")}
					</a>
					.
				</div>
			</div>
		</div>
	);
}
